module.exports = __webpack_public_path__ + "img/logo2.3c2aa4f9.png";